<template>
    <div
        class="select-virtual"
        :class="{
            [theme]: true,
            [cls]: true,
            'mobile': isMobileSize,
            'expend': isShow
        }"
        v-outsideclick="clickOutside"
    >
        <label
            v-if="!hideLabel"
            class="select-text"
            :class="{ ['type-' + type]: true, 'has-value': isSelectActive }"
            @click="toggleDropdown"
        >
            <span v-if="icon" :class="'logo iconfont ' + icon"></span>
            <span>{{ dropdownLabel }}</span>
            <span
                v-if="type === 'dropdown'"
                :class="[
                    'dropdown_icon',
                    'iconfont',
                    iconfontClass,
                    { up: isShow }
                ]"
            ></span>
        </label>
        <div class="select-input-container" :ref="onRef">
            <!--  Input box  -->
            <div
                class="select-input"
                v-if="type === 'input'"
                @click="toggleInput"
            >
                <span v-if="icon" :class="'logo iconfont ' + icon"></span>
                <span class="select-input-value">{{ selectInputValue }}</span>
                <span
                    class="dropdown_icon iconfont icon-small-down"
                ></span>
            </div>
            <template v-if="clientBeforeMount">
                <teleport to="body" v-if="isMobileSize">
                    <DropdownMobile
                        v-if="isMobileSize"
                        :isShow="isShow"
                        :multiple="multiple"
                        :height="height"
                        :itemHeight="itemHeight"
                        :options="defaultOptions"
                        :selectedList="selectedList"
                        :label="label"
                        :theme="theme"
                        :offset="offset"
                        v-bind="$attrs"
                        @clickOption="handleClickOptions"
                        @close="mobileClose"
                        @reset="mobileReset"
                        @submit="mobileSubmit"
                    />
                </teleport>
                <DropdownPC
                    v-else
                    :isShow="isShow"
                    :multiple="multiple"
                    :height="height"
                    :itemHeight="itemHeight"
                    :options="defaultOptions"
                    :theme="theme"
                    :offset="offset"
                    :selectedList="selectedList"
                    v-bind="$attrs"
                    @clickOption="handleClickOptions"
                />
            </template>
        </div>
    </div>
</template>
<script >
import { 
    defineComponent, 
    defineAsyncComponent, 
    reactive, 
    computed, 
    toRefs, 
    getCurrentInstance, 
    ref, 
    watch,
    nextTick,
    onBeforeMount, 
    onMounted
} from 'vue';
import util from '@/common/util';
import global from '@/common/global';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';

export default defineComponent({
    components: { 
        DropdownMobile: defineAsyncComponent(() => import(/* webpackChunkName: "components/virtualize/dropdown/dropdown-mobile"*/ './dropdown/dropdown-mobile.vue')),
        DropdownPC: defineAsyncComponent(() => import(/* webpackChunkName: "components/virtualize/dropdown/dropdown-pc"*/ './dropdown/dropdown-pc.vue'))
    },
    i18next: {
        ns: 'common'
    },
    emits: ['change', 'hideSearch', 'showSearch', 'toogledropdown'],
    props: {
        options: {
            type: Array,
            default: () => []
        },
        multiple: {
            type: Boolean,
            default: false
        },
        // input
        label: {
            type: String,
            default: ''
        },
        // dropdown list
        height: {
            type: Number,
            default: 292
        },
        itemHeight: {
            type: Number,
            default: 42
        },
        icon: {
            type: String,
            default: ''
        },
        value: {
            type: Array,
            default: () => []
        },
        theme: {
            type: String,
            default: 'standard'
        },
        kee: {
            type: String,
            default: ''
        },
        // type: ['input', 'dropdown']
        type: {
            type: String,
            default: 'input'
        },
        inputType: {
            type: String,
            default: ''
        },
        cls: {
            type: String,
            default: ''
        },
        inMore: {
            type: Boolean,
            default: false
        },
        hideLabel: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const { proxy }   = getCurrentInstance();

        const dropdownContainer = ref(null);
        const onRef = (e) => {
            dropdownContainer.value = e
        }

        const store = mapState(usePageStore, { 
            isSearchCenter: store => store.isSearchCenter
        })
        const isSearchCenter = store.isSearchCenter();
        const state = reactive({
            lastOption: null,
            selectedList: [],
            defaultOptions: util.deepClone(props.options),
            isShow: false,
            offset: {
                left: 0,
                top: 0
            },
            selectedListBackup: [],
            clientBeforeMount: false,
        })
        
       
        const isMobileSize = computed(() => proxy.platform.isMobile);
        const dropdownLabel = computed(() => {
            let list = state.selectedList.filter(item => item.value !== '');
            if (isMobileSize.value || props.type === 'input') {
                return props.label;
            } else if (list.length > 1) {
                return `${props.label}(${list.length})`;
            } else if (list.length === 1) {
                return list[0].label;
            } else {
                return props.label;
            }
        });

        const selectInputValue = computed(() => state.selectedList.map(item => item.label).join(','))
        const isSelectActive = computed(() => {
            let len = state.selectedList.length;
            if (state.isShow) {
                return true; 
            }
            if (len === 1) {
                return state.selectedList[0].value !== '';
            }
            return len > 1
        })
        const iconfontClass = computed(() => {
            let cls = 'icon-small-down';
            switch (props.theme) {
            case 'standard':
                if (isMobileSize.value) {
                    cls = 'icon-v3-arrow';
                } else if (!isSearchCenter) {
                    cls = 'icon-arrow-down'
                }
                break;
            case 'template1':
                if (isMobileSize.value) {
                    cls = 'icon-small-down v2-arrow';
                }
                break;
            case 'template4':
                if (isMobileSize.value) {
                    cls = 'icon-v4-arrow';
                }
                break;
            case 'broker': {
                if (!isSearchCenter) {
                    cls = 'icon-arrow-down'
                }
            }
            }
            return cls;
        })

        
        const initOptions = (defaultOptions) => {
            let selectedList = [];
            if (!(defaultOptions instanceof Array)) {
                return []; 
            }
            // Obtain select middle options selected state of
            defaultOptions.forEach(option => {
                let index = props.value.findIndex(item => item + '' === option.value + '');
                option.selected = index >= 0;
                if (index >= 0) {
                    //  order with value be consistent
                    selectedList[index] = option;
                }
            });
            //  Remove empty slots
            selectedList = selectedList.filter(item => typeof item);
            let noSelected = selectedList.length === 0 || (selectedList.length === 1 && selectedList[0].value === '');
            //  Increase any
            if (defaultOptions[0]?.value !== '') {
                defaultOptions.unshift({
                    label: proxy.$t('any'),
                    value: '',
                    selected: noSelected
                });
            } else {
                defaultOptions[0].selected = noSelected;
            }
            if (!state.lastOption && !props.multiple) {
                state.lastOption = selectedList[0]
            }

            state.selectedList =  selectedList;
        }
        
        const clickOutside = () => {
            if (!isMobileSize.value) {
                close();
            }
        }

        const toggleInput = () => {
            if (!state.isShow) {
                //ios  middle fixed Hierarchy failure ， so in reality select Need to temporarily hide when popping up search more bullet box ， turning off select When the drop-down box ， need to show searchmore bullet box
                if (isMobileSize.value) {
                    emit('hideSearch');
                    state.selectedListBackup = state.selectedList.map(item => item);
                }
                state.isShow = true;
                getMobileDropdownOffset();
                emit('toogledropdown', {
                    open: state.isShow,
                    options: props.options,
                    name: props.kee
                });
            } else {
                close();
            }
        }

        const toggleDropdown = () => {
            if (props.type === 'input' && !state.isShow) {
                return; 
            }
            toggleInput();
        }

        const emitChange = () => {
            if (isSearchCenter) {
                emit('change', {
                    kee: props.kee,
                    value: state.selectedList.map(item => item.value),
                    type: props.inputType
                });
            } else {
                emit('change', {
                    kee: props.kee,
                    labels: state.selectedList.map(item => item.label),
                    value: state.selectedList.map(item => item.value).join(','),
                    type: 'select',
                    multiple: props.multiple,
                    split: ',',
                    inMore: props.inMore
                });
            }
        }

        const close = () => {
            state.isShow = false;
            emit('showSearch');
        }

        const mobileClose = () => {
            state.selectedList.forEach(item => (item.selected = false));
            state.selectedListBackup.forEach(item => (item.selected = true));
            state.selectedList = state.selectedListBackup;
            close();
        }

        const mobileReset = () => {
            state.selectedList.forEach(item => (item.selected = false));
            selectAny();
        }

        const mobileSubmit = () => {
            emitChange();
            close();
        }

        const handleClickOptions = (option) => {
            if (!isSelectAny(option)) {
                props.multiple
                    ? selectMultiple(option)
                    : selectSingle(option);
            }
            if (!isMobileSize.value) {
                emitChange();
            }
        }

        const isSelectAny = (option) => {
            if (option.value === '') {
                state.selectedList.forEach(item => (item.selected = false));
                selectAny();
                return true;
            }
        }

        const selectAny = () => {
            state.defaultOptions[0].selected = true;
            state.selectedList = [state.defaultOptions[0]];
        }

        const selectMultiple = (option) => {
            option.selected = !option.selected;
            if (option.selected) {
                state.selectedList.push(option);
                cancelAny();
            } else {
                state.selectedList = state.selectedList.filter(
                    item => item !== option
                );
                if (state.selectedList.length === 0) {
                    selectAny();
                }
            }
        }

        const cancelAny = () => {
            state.defaultOptions[0].selected = false;
            state.selectedList = state.selectedList.filter(
                item => item.value !== ''
            );
        }


        const selectSingle = (option) => {
            state.lastOption && (state.lastOption.selected = false);
            option.selected = !option.selected;
            if (option.selected) {
                state.selectedList = [option];
                cancelAny();
            } else {
                selectAny();
            }
            state.lastOption = option;
        }
        
        const getOffset = function() {
            let { left, top } = dropdownContainer.value?.getBoundingClientRect?.() || {}
            return {
                left, top
            };
        };

        const getMobileDropdownOffset = () => {
            let rect = getOffset();
            state.offset = rect;
            global.scroll(() => {
                if (state.isShow) {
                    state.offset.top = getOffset().top || rect.top;
                }
            });
            watch(() => dropdownLabel.value, () => {
                if (state.isShow) {
                    nextTick(() => {
                        state.offset = getOffset();
                    })
                }
            });
        }
        
        onBeforeMount(() => {
            initOptions(state.defaultOptions);

            watch(() => props.value, (val, oldVal) => {
                if (val.join(',') === oldVal.join(',')) {
                    return; 
                }
                initOptions(state.defaultOptions);
            })

            watch(() => props.options, val => {
                if (val) {
                    let opts = util.deepClone(val);
                    initOptions(opts);
                    state.defaultOptions = opts;
                }
            }, {
                deep: true
            })
            
            nextTick(() => {
                state.clientBeforeMount = true
            })
        })

        onMounted(() => {
            getMobileDropdownOffset()
        })

        
        return {
            ...toRefs(state),
            onRef,
            isMobileSize,
            dropdownLabel,
            selectInputValue,
            isSelectActive,
            iconfontClass,
            clickOutside,
            toggleDropdown,
            mobileClose,
            mobileReset,
            mobileSubmit,
            handleClickOptions,
            toggleInput
        }
    }
})



</script>
<style lang="scss">
@import './scss/standard.scss';
@import './scss/template1.scss';
@import './scss/template4.scss';
@import './scss/broker.scss';
@import './scss/layout1.scss';
.select-virtual.expend {
    .icon-small-down {
        transform: rotate(180deg);
    }
}
</style>